// extracted by mini-css-extract-plugin
export default {"text":"NotFound_text__tvgvE"};